var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ctaBoxes)?_c('div',{class:[
		'c-block-list-custom-cta-boxes-custom w-full mb-80 >=768:mb-120',
		_vm.ctaBoxes.length == 2 ? '>=768:flex >=768:gap-50' : null,
		_vm.ctaBoxes.length > 2
			? '>=768:grid >=768:grid-cols-2 >=768:gap-50'
			: null,
	]},_vm._l((_vm.ctaBoxes),function(box,index){return _c('div',{key:index,class:[
			'group',
			_vm.ctaBoxes.length == 1
				? 'rounded-8 bg-white overflow-hidden >=768:flex >=768:h-620'
				: null,
			_vm.ctaBoxes.length == 2 ? '>=768:w-half' : null,
			_vm.ctaBoxes.length > 2 && index == 0
				? 'rounded-8 bg-white overflow-hidden mb-50 >=768:mb-0 >=768:col-span-2 >=768:flex w-full >=768:h-620'
				: null,
		]},[(box.content.media)?_c('div',{class:[
				'overflow-hidden',
				_vm.ctaBoxes.length == 1 ? '>=768:w-half' : null,
				_vm.ctaBoxes.length == 2 ? 'rounded-8' : null,
				_vm.ctaBoxes.length > 2 && index != 0 ? 'rounded-8' : null,
				_vm.ctaBoxes.length > 2 && index == 0 ? '>=768:w-half' : null,
			]},[_c('UmbracoImageExt',{staticClass:"block w-full",attrs:{"alt":box.content.media.altText,"source-url":box.content.media.cropUrl || box.content.media.path,"source-width":box.content.media.width,"source-height":box.content.media.height,"widths":[320, 417, 768],"aspect-ratio":_vm.ctaBoxes.length == 1
						? 1 / 1
						: _vm.ctaBoxes.length > 2 && index == 0
						? 1 / 1
						: 16 / 9,"image-classes":[
					_vm.ctaBoxes.length > 2 && index == 0
						? 'block object-cover h-full'
						: _vm.ctaBoxes.length > 2 && index != 0
						? 'object-cover'
						: _vm.ctaBoxes.length == 1
						? 'object-cover h-full'
						: null,
				]}})],1):_vm._e(),_vm._v(" "),_c('div',{class:[
				'flex items-center px-20 py-30 >=768:px-0',
				_vm.ctaBoxes.length == 1
					? '>=768:w-half >=768:px-50 >=768:text-24'
					: null,
				_vm.ctaBoxes.length > 2 && index == 0
					? '>=768:w-half >=768:px-50 >=768:text-24'
					: null,
			]},[_c('div',[(box.content.title)?_c('h3',{class:[
						'leading-initial font-bold uppercase',
						_vm.ctaBoxes.length > 2 && index == 0
							? 'text-32'
							: null,
						_vm.ctaBoxes.length == 1 ? 'text-32' : null,
						(_vm.ctaBoxes.length > 2 && index != 0) ||
						_vm.ctaBoxes.length == 2
							? 'mb-15 text-20 >=768:text-24'
							: ':text-32 >=768:text-48 mb-15 >=768:mb-33',
					],domProps:{"innerHTML":_vm._s(box.content.title)}}):_vm._e(),_vm._v(" "),(box.content.teaser)?_c('p',{class:[
						_vm.ctaBoxes.length > 2 && index == 0
							? 'text-14 >=768:text-24'
							: null,
						_vm.ctaBoxes.length == 1
							? 'text-14 >=768:text-24'
							: null,
					],domProps:{"innerHTML":_vm._s(box.content.teaser)}}):_vm._e(),_vm._v(" "),(box.content.link)?_c('a',{directives:[{name:"tracking",rawName:"v-tracking",value:(
						`CTABox, Click, ${box.content.title} - ${_vm.getPath}`
					),expression:"\n\t\t\t\t\t\t`CTABox, Click, ${box.content.title} - ${getPath}`\n\t\t\t\t\t"}],staticClass:"group-hover:bg-action group-hover:cursor-pointer text-white bg-blue rounded-full uppercase px-25 py-12 inline-block mt-25 font-semibold text-16 >=768:mt-30",attrs:{"href":box.content.link.url,"target":box.content.link.target},domProps:{"innerHTML":_vm._s(box.content.link.name)}}):_vm._e()])])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }